import AuthService from "../authService";

export default {
	finalOrder: {
		basketPrice: 0,
		membersPrice: 0,
		totalPrice: 0,
		disc: 0,
		totalDiscountedPrice: 0,
		emailToConfirm: "",
		payLaterText: "",
		selPaymentMethod: 1,
		tranID: 0,
	},
	finalOrderAux: {
		total: 0,
	},
	cart: {
		list: [],
		promo: [],
		donations: [],
		additional: [],
		upsell: [],
		additionalBaskets: [],
		price: 0,
		orderItems: [],
	},
	list: [],
	currentUser: {},
	accessTokenExpired: false,
	isLoggedIn: false,
	userProfile: [],
	profileOptions: [],
	profileOptionsCopy: [],
	profileCustomOptions: [],
	categories: [],
	promotions: [],
	charity: [],
	charitycustom: [],
	orderOptions: [],
	loginInfo: [],
	appCode: Math.random()
		.toString(36)
		.substring(2),
	tempCode: Math.random()
		.toString(36)
		.substring(2),
	organizationInfo: [
		{
			sFrontPage: "",
		},
	],
	auth: new AuthService(),
	shippingCustomOptions: [],
	settings: [],
	// fee settings backup
	feeSettingsBackup: {
		feeActive: null,
		feeRequired: null,
	},
	paymentMethods: [],
	discounts: [],
	total: 0,
	checked_arr: [],
	localDeliveryPricing: [],
	comboPromotions: [],
	sessionId: Math.random()
		.toString(36)
		.substring(2),
	custom: [
		{ displayTitles: [98, 516] },
		{ hasDoorman: [107] },
		{
			disableDelete: [-1000],
		},
		{ noShipCustom: [263, 173] },
	],
	customOptions: {
		displayTitles: [98, 516],
		hasDoorman: [107],
		disableDelete: [-1000],
		noShipCustom: [263, 173, 371],
	},
	showPrices: false,
	listChanged: false,
	lastYear: [],
	transactions: [],
	transaction: [],
	showSpinner: false,
};
/*============================ END OF SECTION ============================*/
